import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { setOutputField } from 'actions/feature/outputs'
import OutputXmcPinEditor from './OutputXmcPinEditor'

const mapDispatchToProps = (dispatch, ownProps) => {
  const { outputId } = ownProps
  const setField = (type) => (value) => setOutputField(type, value, outputId)
  const setEventField = (type) => (event) =>
    setOutputField(type, event.target.value, outputId)

  // TODO: clean this up (bringing in at a more specific level)
  return {
    ...bindActionCreators(
      {
        updatePolarity: setEventField('polarity'),
        updateCurrent: setEventField('current'),
        updateResetType: setEventField('resetType'),
        updateVirtualFuseSetting: setField('virtualFuseSetting'),
        updateResetAttempts: setField('resetAttempts'),
        updateFrequency: setField('frequency'),
        updateDutyCycle: setField('dutyCycle'),
        updateResetDelay: setField('resetDelay'),
      },
      dispatch
    ),
  }
}

export default connect(null, mapDispatchToProps)(OutputXmcPinEditor)
